<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <content-filter-header slot="header" />

    <content-filter :child-id="fromBus.childId"
                    :mode-id="fromBus.modeId" />
  </base-modal>
</template>

<script>
  import ContentFilter from '@/components/Child/ChildContentFilter/ContentFilter'
  import ContentFilterHeader from '@/components/Child/ChildContentFilter/ContentFilterHeader'
  import modalMixin from '@/mixins/modalMixin'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      ContentFilter,
      ContentFilterHeader
    },

    data() {
      return {
        fromBus: {
          modeId: '',
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('content')
    }
  }
</script>
